<template>
  <div class="justify-start items-start">
    <template v-if="el.Id > 0 && !hideInfoBtn">
      <app-icon
        class="cparty-row__info q-mx-xs"
        name="info-circle-outline"
        width="18px"
        color="#979797"
        hover-color="#499259"
        cursor="pointer"
        :title="$t('information')"
        @click="showCPartyInfoMode = true"
      />
      <q-dialog v-model="showCPartyInfoMode" no-shake :full-width="true">
        <counterparty-info-component
          :counterparty-id="el.Id"
          @close="showCPartyInfoMode = false"
        />
      </q-dialog>
    </template>
    <div
      style="display: inline;"
      :class="el.AttachedToClient ? 'text-grey-6' : ''"
      v-html="displayHtml"
    ></div>
    <span
      v-if="!hideRemoveBtn"
      class="cparty-row__remove"
      :title="$t('remove')"
    >
      <app-icon
        name="close"
        width="16px"
        color="#979797"
        hover-color="#616161"
        cursor="pointer"
      />
      <q-menu>
        <q-card>
          <q-card-section class="row items-center">
            <q-avatar icon="delete" size="md" color="grey" text-color="white" />
            <span class="q-ml-sm">
              {{ $t("sure_delete") }}
            </span>
          </q-card-section>

          <q-card-actions @keydown="windowKeyDown" align="right">
            <q-btn
              size="sm"
              flat
              :label="$t('cancel')"
              color="dark"
              :ref="'cancelbtn'"
              v-close-popup
            />
            <q-btn
              size="sm"
              flat
              :label="$t('remove')"
              autofocus
              color="dark"
              :ref="'okbtn'"
              @click="detach"
              v-close-popup
            />
          </q-card-actions>
        </q-card>
      </q-menu>
    </span>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";
import { CounterpartySearched } from "../../../../models/interfaces/finances/counterparty-models";
import { buildClientUrl } from "@/utils/urlHelpers";
import CounterpartyInfoComponent from "../info-dialogs/CounterpartyInfoComponent.vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";

@Component({
  name: "ProjectRow",
  emits: ["show-info", "detach"],
  components: { CounterpartyInfoComponent, AppIcon }
})
export default class CounterpartyRow extends Vue {
  // === PROPS ===
  @Prop({ required: true }) readonly el!: CounterpartySearched;
  @Prop({ type: Boolean, default: false }) readonly hideInfoBtn!: boolean;
  @Prop({ type: Boolean, default: true }) readonly hideRemoveBtn!: boolean;

  showCPartyInfoMode: boolean = false;

  // === Computed: вся строка в v-html ===
  get displayHtml(): string {
    const parts: string[] = [];

    parts.push(`<span class="text-span q-ml-xs">${this.el.Name}</span>`);
    parts.push(
      `<span class="text-span">, ${this.$t('inn')}: ${this.el.TaxpayerNumber}</span>`,
    );

    if (this.el.IsDraft) {
      parts.push(`<span class="text-span q-ml-xs">[${this.$t('draft')}]</span>`);
    }

    if (this.el.Instance1C) {
      parts.push(
        `<span class="text-span q-ml-xs">[${this.el.Instance1C}]</span>`,
      );
    }

    if (this.el.AttachedToClient) {
      parts.push(`<span class="text-span q-ml-xs">(${this.$t('linked_lower')})</span>`);
    }
    return parts.join("");
  }

  get projectURI() {
    return buildClientUrl("project/" + this.el.Id);
  }

  windowKeyDown(e: KeyboardEvent) {
    if (e.key == "ArrowLeft") {
      const that = this;
      setTimeout(() => {
        // @ts-ignore
        that.$refs.cancelbtn && that.$refs.cancelbtn.$el && that.$refs.cancelbtn.$el.focus();
      }, 100);
    } else if (e.key == "ArrowRight") {
      const that = this;
      setTimeout(() => {
        // @ts-ignore
        that.$refs.okbtn && that.$refs.okbtn.$el && that.$refs.okbtn.$el.focus();
      }, 100);
    }
  }

  detach() {
    this.$emit("detach", { Id: this.el.Id });
  }
}
</script>

<style lang="scss" scoped>
.project-row {
  display: inline;
}

.color-marker {
  width: 24px;
  height: 16px;
  margin-right: 6px;
  border-radius: 3px;
}

.green-text {
  color: $primary;
  font-weight: 400;
}

.project-row :deep(.text-medium) {
  font-weight: 500;
}

.project-row :deep(.text-span) {
  color: $primary;
  font-size: 12px;
  cursor: pointer;
}

.inline-flex {
  display: inline-flex;
  align-items: center;
}

.cparty-row__info {
  margin-top: -3px;
}

.cparty-row__remove {
  display: inline-flex;
  line-height: 0;
  vertical-align: middle;
}

</style>
